import styled from "styled-components"

export const FooterSocialMediaWrapper = styled.div`
    display: flex;
    gap:15px;
    align-self: flex-end;

    @media (min-width: 1440px) {
    width: 1240px;
  }
`

export const FooterSocialLink = styled.a`
    line-height:0
`

export const FooterSocialMediaLogo = styled.img`
src: ${(props)=>props.src};
    cursor: pointer;
`